import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import { Message } from 'element-ui'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 添加一个全局的HTTP拦截器以处理token过期
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      Message.error('登录状态已过期，请重新登录');
      // 清除用户信息并跳转到登录页
      store.dispatch('user/resetToken').then(() => {
        // 刷新页面以重置所有状态
        location.href = '/login';
      });
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')